export default __webpack_public_path__ + "static/media/mutual-ic-photo.b94e50a9.svg";